module.exports = __webpack_public_path__ + "static/media/tt_commons_var_roman-webfont.5b3ad8fd.woff2";